<div class="monaco-editor-container position-relative d-flex flex-column h-100"
     cdkDrag cdkDragRootElement=".cdk-overlay-pane"
     cdkDragBoundary="body"
     [cdkDragDisabled]="!toogleDialog"
     [class.dark-theme]="isDarkMode"
     [class.light-theme]="!isDarkMode">

  <div class="modal-header" cdkDragHandle>
    <div class="d-flex align-items-center">
      <h1 class="modal-title">{{ heading }}</h1>
      <div *ngIf="!toogleDialog" class="d-flex align-items-center ms-3">
        <span class="file-label">File:</span>
        <input [(ngModel)]="fileName" id="fileName" type="text" class="fileNameInput">
      </div>
    </div>
  
    <div class="control-buttons">
      <button class="find-button"
              (click)="toggleSearch()"
              (mouseenter)="isExpanded = true"
              (mouseleave)="isExpanded = false"
              [class.active]="isSearchVisible"
              [class.expanded]="isExpanded"
              [title]="isSearchVisible ? 'Close Search (ESC)' : 'Find (Ctrl+F)'">
        <i class="bi" [class.bi-search]="!isSearchVisible" [class.bi-x]="isSearchVisible"></i>
        <span class="button-text">{{ isSearchVisible ? 'Close' : 'Find' }}</span>
      </button>
      <div *ngIf="!toogleDialog" class="dark-mode-toggle" (click)="toggleDarkMode()">
        <input type="checkbox" id="darkModeToggle" [(ngModel)]="isDarkMode" (change)="toggleDarkMode()">
        <label for="darkModeToggle" class="toggle-switch"></label>
      </div>
      <div class="control-button" [title]="toogleFullScreen ? 'Exit full screen' : 'Full screen'"
           (click)="onFullScreen()">
        <i class="bi" [ngClass]="{'bi-fullscreen': !toogleFullScreen, 'bi-fullscreen-exit': toogleFullScreen}"></i>
      </div>
      <div class="min-button" [title]="toogleDialog ? 'Maximize' : 'Minimize'"
           (click)="toogleDialogMinMax()">
        <i class="bi" [ngClass]="{'bi-dash': !toogleDialog, 'bi-square': toogleDialog}"></i>
      </div>
      <div class=" close-button" (click)="onCancel()" title="Close">
        <i class="bi bi-x-lg"></i>
      </div>
    </div>
  </div>
  <!-- Monaco Editor Area -->
  <div class="modal-body">
    <form [formGroup]="editorForm" class="d-flex flex-column h-100">
      <div class="monaco-editor-wrapper">
        <ngx-monaco-editor class="monaco-editor-container"
                           [options]="editorOptions"
                           [(ngModel)]="editorContent"
                           formControlName="content"
                           (onInit)="onInitEditor($event)">
        </ngx-monaco-editor>
      </div>
    </form>
    <ngx-spinner bdColor="rgba(0,0,0,0.5)"
                 size="default"
                 color="var(--primary-color)"
                 type="ball-spin"
                 [fullScreen]="false"
                 name="fileEditor">
      <p class="pleaseWait" style="color: var(--text-color)">Fetching data...</p>
    </ngx-spinner>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-outline-secondary" (click)="onCancel()">Close</button>
    <button [disabled]="spinnerActive"
            type="button"
            class="btn btn-primary"
            (click)="onSubmit()"
            cdkFocusInitial>
      Save
    </button>
  </div>
</div>
